import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsAboutMonthlyPass, ICmsAboutPassResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export const getAboutMonthlyPass = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsAboutMonthlyPassAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "image");

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsAboutPassResponse<ICmsAboutMonthlyPass>>(
    endpointWithParams,
    "GET"
  );
}